"use client";

import { LanguageMenu } from "@tranquility-ai/theme-components/language-menu";
import {
  primaryNavActionClassName,
  primaryNavMenuItemClassName,
} from "@/components/primary-navigation/primary-nav-action";
import { useI18n } from "./LocaleProvider";
import { useLanguageMenuEnabled } from "./language-menu-flag";
import { isAppLocale, localeNativeName } from "./locales";

export function LanguageSelect({
  translatingCount = 0,
  layout = "bar",
}: {
  translatingCount?: number;
  /** `menu` is the full-width row inside the mobile hamburger. */
  layout?: "bar" | "menu";
}) {
  const { locale, setLocale, enabledLocaleOptions, t } = useI18n();
  const menuEnabled = useLanguageMenuEnabled("timepilot");

  if (!menuEnabled) return null;

  return (
    <LanguageMenu
      aria-label={t("common.language")}
      value={locale}
      options={enabledLocaleOptions}
      onValueChange={(code) => {
        if (
          isAppLocale(code) &&
          enabledLocaleOptions.some((option) => option.code === code)
        ) {
          setLocale(code);
        }
      }}
      translatingCount={locale !== "en" ? translatingCount : 0}
      translatingLabel={t("common.translating")}
      translatingTitle={t("common.translatingTo", { language: localeNativeName(locale) })}
      className={layout === "menu" ? "w-full" : undefined}
      placement={layout === "menu" ? "bottom-start" : "bottom-end"}
      triggerClassName={
        layout === "menu" ? primaryNavMenuItemClassName : primaryNavActionClassName(false)
      }
    />
  );
}
